import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import Home from "@/pages/Home";
import SearchResults from "@/pages/SearchResults";
import VehicleDetail from "@/pages/VehicleDetail";
import Checkout from "@/pages/Checkout";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";
import SubscriptionSuccess from "@/pages/SubscriptionSuccess";
import Partner from "@/pages/Partner";
import Activities from "@/pages/Activities";
import Pricing from "@/pages/Pricing";
import About from "@/pages/About";
import FAQ from "@/pages/FAQ";
import Contact from "@/pages/Contact";
import Legal from "@/pages/Legal";
import Login from "@/pages/auth/Login";
import Register from "@/pages/auth/Register";
import ForgotPassword from "@/pages/auth/ForgotPassword";
import ResetPassword from "@/pages/auth/ResetPassword";
import MyBookings from "@/pages/client/MyBookings";
import Profile from "@/pages/client/Profile";
import Rewards from "@/pages/client/Rewards";
import LoueurDashboard from "@/pages/loueur/LoueurDashboard";
import LoueurOnboarding from "@/pages/loueur/Onboarding";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import PartnerDashboard from "@/pages/partner/PartnerDashboard";
import ActivitySuccess from "@/pages/ActivitySuccess";
import ActivityReview from "@/pages/ActivityReview";
import ActivityDetail from "@/pages/ActivityDetail";
import MyFavorites from "@/pages/MyFavorites";

function Protected({ children, roles }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-[60vh] flex items-center justify-center text-canard font-body">Chargement...</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (roles && !roles.includes(user.role)) return <Navigate to="/" replace />;
  return children;
}

function Shell({ children }) {
  return (
    <div className="min-h-screen flex flex-col bg-background">
      <Header />
      <main className="flex-1">{children}</main>
      <Footer />
    </div>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Shell><Home /></Shell>} />
        <Route path="/search" element={<Shell><SearchResults /></Shell>} />
        <Route path="/vehicle/:id" element={<Shell><VehicleDetail /></Shell>} />
        <Route path="/checkout/:id" element={<Shell><Checkout /></Shell>} />
        <Route path="/payment/success" element={<Shell><PaymentSuccess /></Shell>} />
        <Route path="/payment/cancel" element={<Shell><PaymentCancel /></Shell>} />
        <Route path="/subscription/success" element={<Protected roles={["loueur"]}><Shell><SubscriptionSuccess /></Shell></Protected>} />
        <Route path="/partner" element={<Shell><Partner /></Shell>} />
        <Route path="/activites" element={<Shell><Activities /></Shell>} />
        <Route path="/activites/:id" element={<Shell><ActivityDetail /></Shell>} />
        <Route path="/mes-favoris" element={<Shell><MyFavorites /></Shell>} />
        <Route path="/activity-success" element={<Shell><ActivitySuccess /></Shell>} />
        <Route path="/activity-review" element={<Shell><ActivityReview /></Shell>} />
        <Route path="/tarifs" element={<Shell><Pricing /></Shell>} />
        <Route path="/about" element={<Shell><About /></Shell>} />
        <Route path="/faq" element={<Shell><FAQ /></Shell>} />
        <Route path="/contact" element={<Shell><Contact /></Shell>} />
        <Route path="/legal" element={<Shell><Legal /></Shell>} />
        <Route path="/login" element={<Shell><Login /></Shell>} />
        <Route path="/register" element={<Shell><Register /></Shell>} />
        <Route path="/forgot-password" element={<Shell><ForgotPassword /></Shell>} />
        <Route path="/reset-password" element={<Shell><ResetPassword /></Shell>} />
        <Route path="/profile" element={<Protected><Shell><Profile /></Shell></Protected>} />
        <Route path="/rewards" element={<Protected><Shell><Rewards /></Shell></Protected>} />
        <Route path="/my/bookings" element={<Shell><MyBookings /></Shell>} />
        <Route path="/loueur" element={<Protected roles={["loueur"]}><Shell><LoueurDashboard /></Shell></Protected>} />
        <Route path="/loueur/onboarding" element={<Protected roles={["loueur"]}><Shell><LoueurOnboarding /></Shell></Protected>} />
        <Route path="/admin" element={<Protected roles={["superadmin", "sous-admin"]}><Shell><AdminDashboard /></Shell></Protected>} />
        <Route path="/partenaire" element={<Protected roles={["partner"]}><Shell><PartnerDashboard /></Shell></Protected>} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}
